import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class DocumentoAprovadoService {

    constructor(private http: HttpClient) { }

    atualizarDocumentoAprovado(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/DocumentoAprovado/atualizarDocumentoPreEditado`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });
        const options = {
            headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }
}
